import * as React from 'react';

import { Button, Dialog } from '@coursera/cds-core';

import { useTracker } from 'bundles/page/lib/event-pulse/react';

import _t from 'i18n!nls/expression-of-interest';

type Props = {
  email: string;
  handleClose: () => void;
};

export const ConfirmationSection = (props: Props): React.ReactElement => {
  const { email, handleClose } = props;

  const track = useTracker();

  const onClick = () => {
    track('click_button', {
      button: { name: 'degrees_category_hub_explore' },
      pageSection: {
        sectionName: 'eoi',
        subindex: 1,
      },
    });

    handleClose();
  };

  const { HeadingGroup, Content, Actions } = Dialog;

  return (
    <>
      <HeadingGroup>{_t("You're all set!")}</HeadingGroup>

      <Content>
        {_t(
          'You can expect an email sent to #{email} that includes more information about these programs. In the meantime, you can browse our other degrees.',
          { email }
        )}
      </Content>

      <Actions>
        <Button onClick={onClick}>{_t('Browse degrees')}</Button>
      </Actions>
    </>
  );
};

export default ConfirmationSection;
